<template>
<router-view></router-view>
</template>

<script>
export default {
  name: 'App',
  components: {
    
  },
  data () {
    return {
      
    }
  },
  methods: {
    
  }
}  
</script>

<style>
body {
  background-image: url(./assets/imgs/bg.png);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  min-height: 100vh;
  margin: 0;
  padding: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100vh;
  overflow-y: auto;
}
 /* input {
  max-width: 300px;
} */
.el-form {
  --el-form-label-font-size: 16px !important;
}
.el-form-item {
  margin-bottom: 0px;
}
.el-form--inline .el-form-item {
  margin-right: 10px;
}
.el-table th {
  text-align: center !important;
}
.el-table thead {
  color: #606266;
}
.el-dialog__body {
  padding-top: 0px !important;
}

.el-upload-list__item {
    width: 100% !important;
    height: 60vh !important;
}
</style>
